// Fonte: UManutContas.pas — Panel dscidcom → tabela Endereco_Comercial
// Registro unico (PK: Codigo_Conta + codigo_grupo_empresa, sem Seq)
// Validacao: Endereco e Cidade obrigatorios (Delphi linha ~8830)
// Disponivel para: Tipo 2 (Cliente Comercio)
import React, { useState, useEffect, useCallback } from 'react';
import { Card, Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import {
  buscarEnderecoComercialConta,
  salvarEnderecoComercialConta,
  excluirEnderecoComercialConta,
} from '~/Services/Service';
import aplicarMascara from '../components/mascaras';

var TabEnderecoComercial = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;
  var cidades = _ref.cidades !== null && _ref.cidades !== undefined ? _ref.cidades : [];

  var [dados, setDados] = useState(null);
  var [loading, setLoading] = useState(false);
  var [editando, setEditando] = useState(false);
  var [form, setForm] = useState({ endereco: '', bairro: '', cep: '', codigo_cidade: '', fone: '' });
  var [salvando, setSalvando] = useState(false);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    buscarEnderecoComercialConta(ge, codigo)
      .then(function(resp) {
        // API pode retornar objeto unico ou array com 1 elemento
        var registro = Array.isArray(resp) ? (resp.length > 0 ? resp[0] : null) : resp;
        setDados(registro);
        if (registro) {
          setForm({
            endereco: registro.endereco !== null && registro.endereco !== undefined ? registro.endereco : '',
            bairro: registro.bairro !== null && registro.bairro !== undefined ? registro.bairro : '',
            cep: registro.cep !== null && registro.cep !== undefined ? registro.cep : '',
            codigo_cidade: registro.codigo_cidade !== null && registro.codigo_cidade !== undefined ? registro.codigo_cidade : '',
            fone: registro.fone !== null && registro.fone !== undefined ? registro.fone : '',
          });
        }
      })
      .catch(function() { toast.error('Erro ao carregar endereco comercial'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  // Fonte: UManutContas.pas, linha ~8830 — endereco e cidade obrigatorios
  var handleSalvar = function() {
    if (!form.endereco) { toast.warning('Informe o endereco'); return; }
    if (!form.codigo_cidade) { toast.warning('Selecione a cidade'); return; }
    setSalvando(true);
    salvarEnderecoComercialConta(ge, codigo, form)
      .then(function() {
        toast.success('Endereco comercial salvo!');
        setEditando(false);
        carregar();
      })
      .catch(function() { toast.error('Erro ao salvar endereco comercial'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirEnderecoComercialConta(ge, codigo)
      .then(function() {
        toast.success('Endereco comercial removido!');
        setDados(null);
        setForm({ endereco: '', bairro: '', cep: '', codigo_cidade: '', fone: '' });
        setEditando(false);
      })
      .catch(function() { toast.error('Erro ao excluir endereco comercial'); });
  };

  if (loading) return <div className="text-center py-3"><Spinner animation="border" /></div>;

  return (
    <div className="contas-tab-content">
      {!editando && dados && (
        <div className="d-flex justify-content-end mb-2">
          <Button size="sm" variant="outline-primary" className="mr-2" onClick={function() { setEditando(true); }}>Editar</Button>
          <Button size="sm" variant="outline-danger" onClick={handleExcluir}>Remover</Button>
        </div>
      )}
      {!dados && !editando && (
        <div className="d-flex justify-content-end mb-2">
          <Button size="sm" variant="primary" onClick={function() { setEditando(true); }}>
            Informar Endereco Comercial
          </Button>
        </div>
      )}

      {dados && !editando ? (
        <Card className="border-0">
          <Card.Body className="py-2">
            <Row>
              <Col md={4}><small className="text-muted">Endereco:</small><br />{dados.endereco}</Col>
              <Col md={2}><small className="text-muted">Bairro:</small><br />{dados.bairro !== null && dados.bairro !== undefined ? dados.bairro : '-'}</Col>
              <Col md={2}><small className="text-muted">CEP:</small><br />{dados.cep !== null && dados.cep !== undefined ? dados.cep : '-'}</Col>
              <Col md={2}><small className="text-muted">Cidade:</small><br />{dados.descricao_cidade !== null && dados.descricao_cidade !== undefined ? dados.descricao_cidade : '-'}{dados.estado ? ' - ' + dados.estado : ''}</Col>
              <Col md={2}><small className="text-muted">Fone:</small><br />{dados.fone !== null && dados.fone !== undefined ? dados.fone : '-'}</Col>
            </Row>
          </Card.Body>
        </Card>
      ) : editando ? (
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label className="small">Endereco *</Form.Label>
              <Form.Control type="text" size="sm"
                value={form.endereco}
                onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, endereco: v }; }); }}
                maxLength={40}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small">Bairro</Form.Label>
              <Form.Control type="text" size="sm"
                value={form.bairro}
                onChange={function(e) { var v = e.target.value; setForm(function(f) { return { ...f, bairro: v }; }); }}
                maxLength={20}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small">CEP</Form.Label>
              <Form.Control type="text" size="sm"
                value={aplicarMascara(form.cep, 'cep')}
                onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, cep: v }; }); }}
                maxLength={9}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small">Cidade *</Form.Label>
              <Select
                placeholder="Selecione..."
                options={cidades}
                value={cidades.find(function(c) { return c.value === form.codigo_cidade; }) || null}
                onChange={function(opt) { setForm(function(f) { return { ...f, codigo_cidade: opt ? opt.value : '' }; }); }}
                isClearable
                noOptionsMessage={function() { return 'Nenhuma cidade'; }}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small">Fone</Form.Label>
              <Form.Control type="text" size="sm"
                value={aplicarMascara(form.fone, 'fone')}
                onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, fone: v }; }); }}
                maxLength={14}
              />
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Button size="sm" variant="success" className="mr-1" onClick={handleSalvar} disabled={salvando}>
              {salvando ? <Spinner animation="border" size="sm" /> : 'Salvar'}
            </Button>
            <Button size="sm" variant="secondary" onClick={function() { setEditando(false); if (dados) carregar(); }}>Cancelar</Button>
          </Col>
        </Row>
      ) : (
        <p className="text-muted text-center">Nenhum endereco comercial cadastrado.</p>
      )}
    </div>
  );
};

export default TabEnderecoComercial;
